<template>
  <div class="group-info">

    <div class="group-info__logo">
      <img v-if="showLogo" class="img-logo" :src="data.imgSrc"/>
      <span v-else class="text-logo">{{groupName.substring(0, 1)}}</span>
    </div>

    <div class="group-info__title">
      <img v-if="groupNameImg" :src="groupNameImg">
    </div>

    <div class="group-info__extra" v-if="data.extraInfo" v-html="data.extraInfo"></div>
    <div class="group-info__extra" v-if="data.descNoInfo" v-html="data.descNoInfo"></div>
  </div>
</template>

<script>

import { textBecomeImg, canvasWrapText } from "~/utils/getGroupInfo.js"

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showLogo: false,
    }
  },
  computed: {
    bigV() {
      return this.data.bigV === 'BIG_V'
    },
    groupName() {
      return (this.data.groupName || "").slice(0,17) + '...'
    },
    groupNameImg() {
      if (process.client) {
        return textBecomeImg(this.groupName, 18, '#000')
        // return canvasWrapText({
        //   font: "18px 'Microsoft Yahei'",
        //   color: '#000', 
        //   text: this.groupInfo.groupName
        // })
      } else {
        return ""
      }
    }
  },
  mounted() {
    // 加V的群才展示头像 && this.bigV
    if (process.client && this.bigV) {
      const img = new Image();
      img.onload = () => {
        this.showLogo = true
      }
      img.src = this.data.imgSrc
    }
  },
  watch: {
    data() {
      console.log('dddddd')
    }
  },
}
</script>

<style lang="scss">
.group-info {
  padding: 20px 0;
}
.group-info__logo {
  width: 120px;
  height: 120px;
  margin: 0 auto;
  overflow: hidden;
}
.img-logo {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 2px;
  overflow: hidden;
}
.text-logo {
  width: 100%;
  height: 100%;
  background: #3BD2CD;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 50px;
  font-weight: bolder;
  position: relative;
  border-radius: 8px;
  padding-top: 10px;
  box-sizing: border-box;
  overflow: hidden;
}

.group-info__title {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    display: block;
  }
}

.group-info__extra {
  text-align: center;
  font-size: 15px;
  margin-top: 10px;
  word-break: break-all;
  margin-left: auto;
  margin-right: auto;
}
</style>


// WEBPACK FOOTER //
// components/GroupInfo.vue